import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    CircularProgress,
} from "@mui/material";

// Components
import { TextField } from "@/theme/inputs/textfields";

const CreateProductModal = ({ 
    isOpen, 
    onClose, 
    onCreate, 
    creating, 
    product, 
    onChange,
    translate 
}) => {
    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange({
            target: {
                name,
                value
            }
        });
    };
    
    return (
        <Dialog 
            open={isOpen} 
            onClose={() => !creating && onClose()}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>{translate('product.createNew', 'Create New Product')}</DialogTitle>
            <DialogContent>
                <Box sx={{ py: 1 }}>
                    <TextField
                        autoFocus
                        name="name"
                        label={translate('product.name', 'Product Name')}
                        fullWidth
                        value={product.name}
                        onChange={handleChange}
                        disabled={creating}
                        margin="dense"
                        required
                    />
                    <TextField
                        name="seoSlug"
                        label={translate('product.seoSlug', 'SEO Slug')}
                        fullWidth
                        value={product.seoSlug}
                        onChange={handleChange}
                        disabled={creating}
                        margin="dense"
                        helperText={translate('product.seoSlugHelp', 'Custom URL path for the product (optional)')}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose}
                    disabled={creating}
                >
                    {translate('common.cancel', 'Cancel')}
                </Button>
                <Button 
                    onClick={onCreate} 
                    variant="contained" 
                    disabled={creating || !product.name.trim()}
                >
                    {creating ? 
                        <CircularProgress size={24} /> : 
                        translate('common.create', 'Create')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateProductModal;